@if (isLoading) {
  <div class="spinner-wrapper">
    <div class="spinner"></div>
  </div>
}
